/**
 * DO NOT EDIT.
 *
 * This is Relay generated artifact.
 *
 * Please reach out to #jsm-cloud-megatron for any questions.
 *
 * @generated SignedSource<<362b492ffbc276e94915f2993f08553c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type conversationHelpseeker$data = {
  readonly " $fragmentSpreads": FragmentRefs<"messageRendererHelpseeker">;
  readonly " $fragmentType": "conversationHelpseeker";
};
export type conversationHelpseeker$key = {
  readonly " $data"?: conversationHelpseeker$data;
  readonly " $fragmentSpreads": FragmentRefs<"conversationHelpseeker">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "conversationHelpseeker",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "messageRendererHelpseeker"
    }
  ],
  "type": "User",
  "abstractKey": "__isUser"
};

(node as any).hash = "68ceebceebfa88ba7faeb75f477f24e5";

export default node;
